import { Heart } from "lucide-react";
import { Reveal, ChapterLabel } from "./Motion";
import { POSTS, EDITORIAL } from "../../data/content";

export const Ch5Posts = () => (
  <section id="chapter-5" className="relative py-24 sm:py-36 overflow-hidden">
    <div
      className="absolute inset-0 bg-cover bg-center opacity-[0.14]"
      style={{ backgroundImage: `url(${EDITORIAL.momentBg})` }}
    />
    <div className="absolute inset-0 bg-cream/85" />

    <div className="relative mx-auto max-w-[1200px] px-6 sm:px-10">
      <Reveal><ChapterLabel index="Chapter Five" title="Real Moments" /></Reveal>
      <Reveal delay={0.1}>
        <h2 className="serif-display mt-8 max-w-2xl text-[2rem] sm:text-[2.7rem] font-light text-charcoal leading-[1.1]">
          In their own words.
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-x-20 gap-y-20 sm:grid-cols-2">
        {POSTS.map((p, i) => (
          <Reveal key={p.text} delay={(i % 2) * 0.12} className={i % 2 === 1 ? "sm:mt-20" : ""}>
            <figure className="border-t border-charcoal/15 pt-8">
              <blockquote className="serif-display text-[1.7rem] sm:text-[2rem] font-light leading-[1.3] text-charcoal">
                “{p.text}”
              </blockquote>
              <figcaption className="mt-7 flex flex-wrap items-center justify-between gap-3 text-sm text-ink/60">
                <span className="font-medium text-sage-deep">{p.user}</span>
                <span className="flex items-center gap-2.5">
                  <Heart size={15} className="text-sage fill-sage/40" />
                  <span><span className="font-medium text-sage-deep">{p.count}</span> {p.label}</span>
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-20 text-center text-xs uppercase tracking-[0.24em] text-taupe">
          Illustrative moments · shared under private usernames on HEARD
        </p>
      </Reveal>
    </div>
  </section>
);
